var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilderCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.95312C7.98504 1.95312 6.12547 2.61849 4.6259 3.74349V0H1V10.1562H4.69194C5.09597 7.57421 7.31813 5.59895 10 5.59895C12.9681 5.59895 15.3741 8.01822 15.3741 11.0026C15.3741 13.6536 13.4757 15.8594 10.9712 16.3177V20C15.4842 19.513 19 15.6706 19 11.0026C19 6.0052 14.9701 1.95312 10 1.95312Z",
    fill: "#668598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85482 12H1C1.47845 16.2698 5.05383 19.6536 9.53295 20.0503V16.3703C7.1639 16.0141 5.28283 14.2498 4.85482 12Z",
    fill: "#00A0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilderCredit);
export default __webpack_public_path__ + "static/media/builder-credit.0322da2a8c5adbc2328deeea1560726b.svg";
export { ForwardRef as ReactComponent };